import React from 'react';
import classes from './BlitzAuth.module.scss';
import external_auth from 'api/auth_external';
import { ConfigProvider, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { functionCollectBrowserData } from 'helpers/browserData/functionCollectBrowserData';

const BlitzAuth = () => {
  const [messageApi, messageHolder] = message?.useMessage();

  const { t } = useTranslation();

  const getAuthLinkAndRedirect = async () => {
    const browserData = await functionCollectBrowserData();
    const formData = new FormData();
    formData.append('browser_data', JSON.stringify(browserData) || '');
    
    try {
      const authLink = await external_auth.getLoginUrl(formData);
      window.location.href = authLink.data.url;
    } catch (e) {
      console.log(e, 'Blitz auth error!');
      messageApi.error(t('external_auth.error'));
    }
  };

  React.useEffect(() => {
    getAuthLinkAndRedirect();
  }, []);

  return (
    <div className={classes.lds}>
      <ConfigProvider>{messageHolder}</ConfigProvider>
      <div className={classes.ldsRipple}><div></div><div></div></div>
    </div>
  );
}

export default BlitzAuth;
